export default "__VITE_ASSET__20d8ab2b__"